import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import {
  Navbar,
  NavbarBrand,
} from 'reactstrap';

import logo from '../../assets/images/logo.svg';
import logoDark from '../../assets/images/logoDarkNoBadge.svg';

import { HeaderCompany } from './components/HeaderCompany/index';
import { HeaderDashboard } from './components/HeaderDashboard/index';
import { HeaderAssessmentManager } from './components/HeaderAssessmentManager/index';
import { HeaderAssessmentReport } from './components/HeaderAssessmentReport/index';
import { HeaderQuestion } from './components/HeaderQuestion/index';

import './header.css';

class Header extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      isShowConfirm: false
    }
  }

  showConfirm = () => {
    this.setState({
      isShowConfirm: !this.state.isShowConfirm
    })
  }

  navigateToDashboard = () => {
    this.setState({
      isShowConfirm: false
    })
    this.props.history.push('/dashboard');
  }

  toggle = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  handleClickLogo = () => {
    const { location } = this.props.history;
    if (location.pathname.includes("/question")) {
      this.showConfirm();
    }
    else {
      window.scrollTo(0, 0);
      this.props.history.push('/');
    }
  }

  render() {
    const { location } = this.props.history;
    let headerCenter, headerStyle, headerLogo;
    switch (location.pathname) {
      case '/dashboard': {
        headerStyle = 'app-header-white';
        headerCenter = <HeaderDashboard key={1} {...this.props} isOpen={this.state.isOpen} />;
        headerLogo = <img className="app-logo" alt="" src={logoDark} />
        break;
      }
      case '/assessment-manager': {
        headerStyle = 'app-header-white';
        headerCenter = <HeaderAssessmentManager key={2} {...this.props} />;
        headerLogo = <img className="app-logo" alt="" src={logoDark} />
        break;
      }
      case '/question': {
        headerStyle = 'app-header-question';
        headerCenter = <HeaderQuestion isShowConfirm={this.state.isShowConfirm} showConfirm={this.showConfirm} navigateToDashboard={this.navigateToDashboard} key={3} {...this.props} saveAnsweredQuestions={this.props.saveAnsweredQuestions} />;
        headerLogo = <img className="app-logo" alt="" src={logo} />
        break;
      }
      case '/assessment-report': {
        headerStyle = 'app-header';
        headerCenter = <HeaderAssessmentReport key={4}  {...this.props} />;
        headerLogo = <img className="app-logo" alt="" src={logo} />
        break;
      }
      case '/company': {
        headerStyle = 'app-header-white';
        headerCenter = <HeaderCompany key={5}  {...this.props} />;
        headerLogo = <img className="app-logo" alt="" src={logoDark} />
        break;
      }
      default: {
        headerStyle = 'app-header';
        headerCenter = <HeaderDashboard key={8} noDropdown={true} {...this.props} />;
        headerLogo = <img className="app-logo" alt="" src={logo} />
        break;
      }
    }

    return (
      location.pathname !== '/' ?
        <Navbar color="faded" light fixed="top" expand="lg" className={headerStyle}>
          <NavbarBrand className="mr-auto navbar-brand" onClick={this.handleClickLogo}>
            {headerLogo}
          </NavbarBrand>
          {headerCenter}
        </Navbar>
        : <div></div>
    )
  }
}

export default withRouter(Header);



// WEBPACK FOOTER //
// ./src/components/Header/Header.js